import React from 'react';

var InfoIcon = function InfoIcon() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 23 23"
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#3E3E3E",
    fillRule: "nonzero",
    d: "M11.808 7.12c-.341 0-.597-.096-.768-.288-.17-.192-.256-.437-.256-.736 0-.341.104-.624.312-.848.208-.224.493-.336.856-.336s.63.096.8.288c.17.192.256.437.256.736 0 .363-.104.65-.312.864-.208.213-.499.32-.872.32h-.016zm-.64 2.832l-1.216-.288v-.848l2.48-.304h.032l.368.288v7.888l1.28.128v.784h-4.24v-.784l1.296-.144v-6.72z"
  }), React.createElement("circle", {
    cx: "11.5",
    cy: "11.5",
    r: "10.5",
    stroke: "#3E3E3E",
    strokeWidth: "2"
  })));
};

export default InfoIcon;